import styled from 'styled-components/macro';


export const MainContainer = styled.div `
    display: flex;
    flex-direction: column;
    background-color: #f6f6f6;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: 3rem;
`;
